import { action } from 'sky-engine/api/index'

import { EVN_CONFIRM_MNG } from '@/api/apiModules'
/**
 * 获取环境部署信息的确认信息
 * @param {*} data
 * @returns
 */
export function getEnvDetail(data) {
  return action(EVN_CONFIRM_MNG, 'detail', data)
}

/**
 * 保存环境确认信息
 * @param {*} data
 * @returns
 */
export function updateSceneRealtionEnv(data) {
  return action(EVN_CONFIRM_MNG, 'save', data)
}

/**
 * 服务器配置计算
 * @param {*} data
 * @returns
 */
export function serverCalculator(data) {
  return action(EVN_CONFIRM_MNG, 'server/calculator', data)
}
